"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalInnerToolbarLayout = exports.HorizontalInnerToolbarLayout = exports.VerticalToolbarLayout = exports.HorizontalToolbarLayout = exports.supportFieldLineLayout = exports.ToolbarParent = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const toolbarParent_1 = require("./toolbarParent");
Object.defineProperty(exports, "supportFieldLineLayout", { enumerable: true, get: function () { return toolbarParent_1.supportFieldLineLayout; } });
Object.defineProperty(exports, "ToolbarParent", { enumerable: true, get: function () { return toolbarParent_1.ToolbarParent; } });
exports.HorizontalToolbarLayout = (0, styled_components_1.default)(toolbarParent_1.ToolbarParent).attrs({
    layoutType: 'horizontal',
}) `
  & > :not(:first-child) {
    margin-left: -1px;
  }

  display: flex;
  align-items: stretch;
`;
exports.VerticalToolbarLayout = (0, styled_components_1.default)(toolbarParent_1.ToolbarParent).attrs({
    layoutType: 'vertical',
}) `
  & > :not(:first-child) {
    margin-top: -1px;
  }

  display: flex;
  flex-direction: column;
  align-items: stretch;
`;
exports.HorizontalInnerToolbarLayout = (0, styled_components_1.default)(toolbarParent_1.ToolbarParent).attrs({
    layoutType: 'inner',
}) `
  & > :not(:first-child) {
    margin-left: -1px;
  }

  display: flex;
  align-items: stretch;
`;
exports.VerticalInnerToolbarLayout = (0, styled_components_1.default)(toolbarParent_1.ToolbarParent).attrs({
    layoutType: 'inner',
}) `
  & > :not(:first-child) {
    margin-top: -1px;
  }

  display: flex;
  flex-direction: column;
  align-items: stretch;
`;
//# sourceMappingURL=index.js.map